// Guess — გამოიცანი: interface texts (ka default, en, ru).
import type { Lang } from "@shared/types";
import { useLocalDict } from "../../i18n/local";

const ka = {
  name: "Guess — გამოიცანი",
  short: "გამოიცანი",
  tagline: "დაინახე. თქვი. გადაეცი სვლა.",
  heroSub: "სურათი ეკრანზე, პასუხი — ხმით. ყველას თავისი 60 წამი აქვს: სწორი პასუხი სვლას გადასცემს, შეცდომა საათს აკლებს.",
  start: "თამაშის დაწყება",
  history: "ჩემი მატჩები",
  howTitle: "როგორ ვთამაშობთ",
  how: [
    "ორი მოთამაშე, ერთი ტელეფონი. ტელეფონი შუაში დადეთ.",
    "სურათს ხედავ — პასუხს ხმამაღლა ამბობ. ქართულად ან ინგლისურად.",
    "სწორი პასუხი შენს საათს აჩერებს და სვლა მეორეზე გადადის.",
    "ვინც ბოლომდე შეინარჩუნებს დროს, ის იგებს.",
  ],
  rulesTitle: "წესები",
  rulesText: "თითოეულ მოთამაშეს აქვს 60 წამი. სწორი პასუხი გადასცემს სვლას. შეცდომა და გამოტოვება აკლებს 3 წამს.",
  rulesBullets: [
    "პასუხობს მხოლოდ ის, ვისი სვლაცაა. მეორე — ჩუმად!",
    "სურათის გამოსატოვებლად თქვი „გამოტოვება“ (ან „skip“).",
    "თუ ვერ გაგიგეთ, გაიმეორე — ამაში დრო არ გაკლდება.",
    "„ან“-ით ორი პასუხი და უარყოფა („არაა“) არ ითვლება.",
  ],
  ready: "მზად ვართ!",
  steps: ["მოთამაშეები", "ხმა", "კატეგორია", "წესები"],
  // setup: players
  playersTitle: "ვინ თამაშობს?",
  playersSub: "ორი მოთამაშე ერთ ტელეფონზე. შეგიძლია მეტიც დაამატო — ექვსამდე.",
  playerN: "მოთამაშე {n}",
  you: "შენ",
  guest: "სტუმარი",
  addPlayer: "მოთამაშის დამატება",
  removePlayer: "წაშლა",
  namePh: "სახელი",
  nameRequired: "ყველა მოთამაშეს სახელი სჭირდება",
  namesUnique: "სახელები განსხვავებული უნდა იყოს",
  next: "შემდეგი",
  back: "უკან",
  saveNote: "შენი მატჩები და სტატისტიკა შენს პროფილში შეინახება. სტუმრის შედეგი შენს სტატისტიკაში არ ჩაითვლება.",
  loginNote: "შედი, რომ მატჩების ისტორია და ხმის პროფილი შეინახო.",
  // mic
  micTitle: "მიკროფონი",
  micWhy: "თამაში პასუხებს ხმით იღებს. მიკროფონი მხოლოდ თამაშის დროს ჩაირთვება.",
  micAllow: "მიკროფონის ჩართვა",
  micDenied: "მიკროფონზე წვდომა დაბლოკილია. ჩართე ბრაუზერის პარამეტრებში და სცადე თავიდან.",
  micMissing: "მიკროფონი ვერ ვიპოვეთ.",
  micInsecure: "მიკროფონი მხოლოდ დაცულ (https) გვერდზე მუშაობს.",
  sttUnavailable: "ამ ბრაუზერში ხმის ამოცნობა არ მუშაობს. გახსენი Chrome-ში ან Edge-ში.",
  privacyServer: "ხმა მხოლოდ ამოცნობისთვის იგზავნება ({provider}) და არ ინახება. ვინახავთ მხოლოდ ტექსტს — რა გაიგო სისტემამ.",
  privacyBrowser: "ხმის ამოცნობას ბრაუზერი აკეთებს (Chrome-ში — Google-ის სერვისით). ჩვენ მხოლოდ ტექსტს ვიღებთ.",
  // voice test
  testTitle: "ხმის შემოწმება",
  testSub: "{name}, თქვი ეს ხუთი სიტყვა. ტესტი გავლილია, როცა ხუთივე სწორად გაიგება.",
  testSay: "თქვი:",
  testHeard: "გავიგე: {text}",
  testNothing: "ვერაფერი გავიგე",
  testRetry: "ეს სიტყვა კიდევ ერთხელ",
  testPassed: "ხმა შემოწმებულია ✓",
  testLang: "ტესტის ენა",
  testProfile: "ხმის პროფილი დადასტურებულია ({date})",
  testRetake: "ხელახლა გავლა",
  testUseProfile: "პროფილით გაგრძელება",
  testKeep: "ჩემი ტესტის ჩანაწერები შეინახე {days} დღით (დაშიფრული, მხოლოდ ჩემთვის)",
  testListening: "გისმენ…",
  testChecking: "ვამოწმებ…",
  testLevel: "მიკროფონის დონე",
  testTooQuiet: "ძალიან ჩუმად ისმის — ტელეფონთან ახლოს ილაპარაკე.",
  // category
  catTitle: "აირჩიე კატეგორია",
  catCount: "{n} სურათი",
  catLoadError: "კატეგორიები ვერ ჩაიტვირთა",
  // countdown & duel
  countdownGo: "წავედით!",
  turnOf: "პასუხობს {name}",
  listening: "გისმენ",
  hearing: "მესმის…",
  checking: "ვამოწმებ…",
  correct: "სწორია!",
  wrong: "არასწორია",
  skip: "გამოტოვება",
  minus3: "−3 წამი",
  itWas: "ეს იყო: {answer}",
  unclear: "ვერ გავიგე — გაიმეორე",
  ignored: "არ ჩაითვალა",
  negated: "უარყოფა არ ითვლება",
  multiple: "ერთი პასუხი თქვი",
  other: "ეს სხვა რამეა",
  heard: "გავიგე: „{text}“",
  techPause: "ტექნიკური პაუზა",
  techPauseText: "ამოცნობის სერვისმა ვერ უპასუხა. დრო გაჩერებულია — არავის აკლდება.",
  pausedTitle: "პაუზა",
  pausedText: "საათები გაჩერებულია.",
  resume: "გაგრძელება",
  quit: "თამაშის დასრულება",
  quitConfirm: "დავასრულოთ? ეს მატჩი ისტორიაში არ ჩაიწერება.",
  out: "დრო ამოეწურა!",
  lastSeconds: "ბოლო წამები!",
  bankEmpty: "სურათები ამოიწურა — იგებს ის, ვისაც მეტი დრო დარჩა.",
  loadingPictures: "სურათები იტვირთება…",
  // results
  winner: "გაიმარჯვა {name}!",
  draw: "ფრეა!",
  soloScore: "{n} სწორი პასუხი",
  statsCorrect: "სწორი",
  statsWrong: "შეცდომა",
  statsSkips: "გამოტოვება",
  statsTime: "დარჩენილი დრო",
  statsThink: "საშუალოდ",
  rematch: "რევანში",
  changeCategory: "სხვა კატეგორია",
  toHistory: "ისტორია",
  review: "რა გაიგო სისტემამ",
  saved: "მატჩი შენახულია",
  saveFailed: "მატჩის შენახვა ვერ მოხერხდა",
  unverified: "შეუმოწმებელი",
  // history
  historyTitle: "მატჩების ისტორია",
  historyEmpty: "ჯერ არცერთი მატჩი. დროა პირველი ითამაშო!",
  historyLogin: "ისტორიის სანახავად შედი ანგარიშზე.",
  won: "მოგება",
  lost: "წაგება",
  drew: "ფრე",
  vs: "vs",
  seconds: "{n} წმ",
  detailTitle: "მატჩის დეტალები",
  notFound: "მატჩი ვერ მოიძებნა",
  verdicts: { correct: "სწორი", wrong: "შეცდომა", skip: "გამოტოვება", unclear: "გაურკვეველი", ignored: "არ ჩაითვალა", error: "ტექნ. შეცდომა" } as Record<string, string>,
  // account
  accTitle: "Guess — გამოიცანი",
  accStats: "სტატისტიკა",
  accMatches: "მატჩი",
  accWins: "მოგება",
  accAccuracy: "სიზუსტე",
  accThink: "საშ. პასუხის დრო",
  accBest: "საუკეთესო კატეგორია",
  accVoice: "ხმის პროფილი",
  accVoiceNone: "ხმის პროფილი ჯერ არ გაქვს. ის პირველი თამაშისას შეიქმნება.",
  accVoicePassed: "დადასტურებული: {date} · ენა: {lang}",
  accVoiceStored: "რას ვინახავთ",
  accVoiceStoredList: [
    "ტესტის სიტყვები და რა გაიგო სისტემამ",
    "ტესტის შედეგი და თარიღი",
    "მიკროფონის დონეები (ფონის ხმაური და ხმის სიძლიერე) — ხმის უკეთ ამოსაცნობად",
  ],
  accVoiceNotStored: "მატჩის აუდიოს არ ვინახავთ. ტესტის ჩანაწერებს — მხოლოდ შენი თანხმობით, დაშიფრულს და {days} დღით.",
  accSamples: "შენახული ჩანაწერები",
  accSamplesNone: "ჩანაწერები არ ინახება.",
  accKeepSamples: "ტესტის ჩანაწერების შენახვა",
  accSamplesOff: "ამ სერვერზე ჩანაწერების შენახვა გამორთულია.",
  accRetake: "ტესტის ხელახლა გავლა",
  accDelete: "ხმის პროფილის წაშლა",
  accDeleteConfirm: "წაიშლება პროფილი, ტესტები და ყველა ჩანაწერი. დარწმუნებული ხარ?",
  accDeleted: "ხმის პროფილი წაიშალა",
  play: "მოსმენა",
  delete: "წაშლა",
  langs: { ka: "ქართული", en: "English" } as Record<string, string>,
  online: {
    start: "ონლაინ ოთახი",
    badge: "ონლაინ",
    sub: "ყველა — თავისი ტელეფონით. ერთი კოდი, ერთი ოთახი.",
    create: "ოთახის შექმნა",
    nameTitle: "ონლაინ ოთახი",
    lobbyNote: "თითოეული პასუხობს თავისი ტელეფონით: ჯერ ხმის შემოწმება 5 სიტყვით, მერე — ყველას თავისი 60 წამი.",
    catLabel: "კატეგორია",
    change: "შეცვლა",
    hostPicks: "კატეგორიას ჰოსტი ირჩევს",
    checkTitle: "ხმის შემოწმება",
    checkSub: "ყველა თავის ტელეფონზე ამოწმებს ხმას. როცა ყველა მზად იქნება, თამაში თავისით დაიწყება.",
    checkReady: "მზადაა",
    checkPending: "ამოწმებს…",
    checkLeft: "გავიდა",
    waitingFor: "ველოდებით: {names}",
    youPassed: "შენი ხმა მზადაა. ველოდებით დანარჩენებს.",
    spectator: "უყურებ. პასუხობენ მოთამაშეები — თავიანთი ტელეფონებით.",
    yourTurn: "შენი სვლაა — თქვი!",
    quiet: "ახლა {name} პასუხობს. შენი მიკროფონი ისვენებს.",
    micNote: "მიკროფონი მხოლოდ შენს სვლაზე ისმენს.",
    resumeHint: "გაგრძელება შეუძლია ჰოსტს ან იმას, ვისი სვლაცაა.",
    waitHost: "ჰოსტი წყვეტს, რა იქნება შემდეგ.",
    toLobby: "ოთახში დაბრუნება",
    callOff: "მატჩის შეწყვეტა",
    callOffConfirm: "მატჩი შეწყდება და შედეგი არ შეინახება. შევწყვიტოთ?",
    calledOff: "მატჩი შეწყდა",
    onlyServer: "ონლაინ ოთახი მხოლოდ სრულ ვერსიაში მუშაობს",
    sendFailed: "პასუხი ვერ გაიგზავნა — თქვი თავიდან",
  },
  errors: {
    no_content: "ეს კატეგორია ჯერ მზად არ არის",
    rate_limited: "ძალიან ბევრი მოთხოვნა — ცოტა ხანში სცადე",
    stt_unavailable: "ხმის ამოცნობის სერვისი მიუწვდომელია",
    network: "ინტერნეტთან კავშირი შეწყდა",
    server: "სერვერის შეცდომა — სცადე თავიდან",
  } as Record<string, string>,
};

export type GuessDict = typeof ka;

const en: GuessDict = {
  name: "Guess",
  short: "Guess",
  tagline: "See it. Say it. Pass the turn.",
  heroSub: "A picture on screen, the answer out loud. Everyone has 60 seconds: a right answer passes the turn, a mistake costs time.",
  start: "Start a game",
  history: "My matches",
  howTitle: "How to play",
  how: [
    "Two players, one phone. Put it between you.",
    "You see a picture and say the answer out loud — in Georgian or English.",
    "A right answer stops your clock and the turn passes to the other player.",
    "Whoever keeps time on the clock the longest wins.",
  ],
  rulesTitle: "Rules",
  rulesText: "Each player has 60 seconds. A right answer passes the turn. A mistake or a skip costs 3 seconds.",
  rulesBullets: [
    "Only the player whose turn it is answers. The other one stays quiet!",
    "To skip a picture, say “skip” (or „გამოტოვება“).",
    "If we didn’t catch it, say it again — that costs no time.",
    "Two answers with “or” and denials (“it’s not…”) don’t count.",
  ],
  ready: "We’re ready!",
  steps: ["Players", "Voice", "Category", "Rules"],
  playersTitle: "Who’s playing?",
  playersSub: "Two players on one phone. You can add more — up to six.",
  playerN: "Player {n}",
  you: "You",
  guest: "Guest",
  addPlayer: "Add a player",
  removePlayer: "Remove",
  namePh: "Name",
  nameRequired: "Every player needs a name",
  namesUnique: "Names must be different",
  next: "Next",
  back: "Back",
  saveNote: "Your matches and stats are saved to your profile. A guest’s result never counts in your stats.",
  loginNote: "Sign in to keep your match history and voice profile.",
  micTitle: "Microphone",
  micWhy: "The game takes answers by voice. The microphone is on only while you play.",
  micAllow: "Turn on the microphone",
  micDenied: "Microphone access is blocked. Allow it in your browser settings and try again.",
  micMissing: "No microphone found.",
  micInsecure: "The microphone only works on a secure (https) page.",
  sttUnavailable: "Speech recognition doesn’t work in this browser. Open the game in Chrome or Edge.",
  privacyServer: "Your voice is sent only for recognition ({provider}) and is not stored. We keep only the text — what the system heard.",
  privacyBrowser: "Your browser does the speech recognition (in Chrome, using Google’s service). We receive only text.",
  testTitle: "Voice check",
  testSub: "{name}, say these five words. You pass when all five are understood.",
  testSay: "Say:",
  testHeard: "Heard: {text}",
  testNothing: "Didn’t catch anything",
  testRetry: "This word once more",
  testPassed: "Voice checked ✓",
  testLang: "Test language",
  testProfile: "Voice profile confirmed ({date})",
  testRetake: "Retake",
  testUseProfile: "Continue with profile",
  testKeep: "Keep my test recordings for {days} days (encrypted, only for me)",
  testListening: "Listening…",
  testChecking: "Checking…",
  testLevel: "Microphone level",
  testTooQuiet: "You sound very quiet — speak closer to the phone.",
  catTitle: "Pick a category",
  catCount: "{n} pictures",
  catLoadError: "Couldn’t load the categories",
  countdownGo: "Go!",
  turnOf: "{name}’s turn",
  listening: "Listening",
  hearing: "Hearing you…",
  checking: "Checking…",
  correct: "Correct!",
  wrong: "Wrong",
  skip: "Skipped",
  minus3: "−3 seconds",
  itWas: "It was: {answer}",
  unclear: "Didn’t catch that — say it again",
  ignored: "Didn’t count",
  negated: "A denial doesn’t count",
  multiple: "Say one answer",
  other: "That’s something else",
  heard: "Heard: “{text}”",
  techPause: "Technical pause",
  techPauseText: "The recognition service didn’t answer. The clocks are stopped — nobody loses time.",
  pausedTitle: "Paused",
  pausedText: "The clocks are stopped.",
  resume: "Resume",
  quit: "End the game",
  quitConfirm: "End it now? This match won’t be saved to the history.",
  out: "Out of time!",
  lastSeconds: "Last seconds!",
  bankEmpty: "No pictures left — whoever has more time wins.",
  loadingPictures: "Loading pictures…",
  winner: "{name} wins!",
  draw: "It’s a draw!",
  soloScore: "{n} right answers",
  statsCorrect: "Right",
  statsWrong: "Wrong",
  statsSkips: "Skips",
  statsTime: "Time left",
  statsThink: "Average",
  rematch: "Rematch",
  changeCategory: "Another category",
  toHistory: "History",
  review: "What the system heard",
  saved: "Match saved",
  saveFailed: "Couldn’t save the match",
  unverified: "Unverified",
  historyTitle: "Match history",
  historyEmpty: "No matches yet. Time for your first one!",
  historyLogin: "Sign in to see your history.",
  won: "Won",
  lost: "Lost",
  drew: "Draw",
  vs: "vs",
  seconds: "{n} s",
  detailTitle: "Match details",
  notFound: "Match not found",
  verdicts: { correct: "Right", wrong: "Wrong", skip: "Skip", unclear: "Unclear", ignored: "Didn’t count", error: "Tech error" },
  accTitle: "Guess",
  accStats: "Stats",
  accMatches: "Matches",
  accWins: "Wins",
  accAccuracy: "Accuracy",
  accThink: "Avg. answer time",
  accBest: "Best category",
  accVoice: "Voice profile",
  accVoiceNone: "You don’t have a voice profile yet. It’s created the first time you play.",
  accVoicePassed: "Confirmed: {date} · language: {lang}",
  accVoiceStored: "What we store",
  accVoiceStoredList: ["The test words and what the system heard", "The test result and its date", "Microphone levels (background noise and voice loudness) to detect your voice better"],
  accVoiceNotStored: "We never store match audio. Test recordings only with your consent, encrypted, for {days} days.",
  accSamples: "Stored recordings",
  accSamplesNone: "No recordings are stored.",
  accKeepSamples: "Keep my test recordings",
  accSamplesOff: "Keeping recordings is switched off on this server.",
  accRetake: "Retake the test",
  accDelete: "Delete voice profile",
  accDeleteConfirm: "This deletes the profile, the tests and every recording. Are you sure?",
  accDeleted: "Voice profile deleted",
  play: "Play",
  delete: "Delete",
  langs: { ka: "Georgian", en: "English" },
  online: {
    start: "Online room",
    badge: "online",
    sub: "Everyone on their own phone. One code, one room.",
    create: "Create a room",
    nameTitle: "Online room",
    lobbyNote: "Everyone answers on their own phone: first a 5-word voice check, then 60 seconds each.",
    catLabel: "Category",
    change: "Change",
    hostPicks: "The host picks the category",
    checkTitle: "Voice check",
    checkSub: "Everyone checks their voice on their own phone. The game starts by itself once everybody is ready.",
    checkReady: "Ready",
    checkPending: "Checking…",
    checkLeft: "Left",
    waitingFor: "Waiting for: {names}",
    youPassed: "Your voice is ready. Waiting for the others.",
    spectator: "You’re watching. The players answer on their own phones.",
    yourTurn: "Your turn — say it!",
    quiet: "{name} is answering now. Your microphone is resting.",
    micNote: "Your microphone only listens on your turn.",
    resumeHint: "The host or the player whose turn it is can go on.",
    waitHost: "The host decides what’s next.",
    toLobby: "Back to the room",
    callOff: "Call the match off",
    callOffConfirm: "The match stops and nothing is saved. Call it off?",
    calledOff: "The match was called off",
    onlyServer: "Online rooms only work in the full version",
    sendFailed: "Your answer didn’t get through — say it again",
  },
  errors: {
    no_content: "This category isn’t ready yet",
    rate_limited: "Too many requests — try again in a moment",
    stt_unavailable: "The speech recognition service is unavailable",
    network: "The connection dropped",
    server: "Server error — please try again",
  },
};

const ru: GuessDict = {
  ...en,
  name: "Guess — Угадай",
  short: "Угадай",
  tagline: "Увидел. Сказал. Передал ход.",
  heroSub: "Картинка на экране, ответ — голосом. У каждого свои 60 секунд: верный ответ передаёт ход, ошибка отнимает время.",
  start: "Начать игру",
  history: "Мои матчи",
  howTitle: "Как играть",
  how: [
    "Два игрока, один телефон. Положите его между собой.",
    "Видишь картинку — говоришь ответ вслух, по-грузински или по-английски.",
    "Верный ответ останавливает твои часы, и ход переходит к сопернику.",
    "Побеждает тот, у кого время продержится дольше.",
  ],
  rulesTitle: "Правила",
  rulesText: "У каждого игрока 60 секунд. Верный ответ передаёт ход. Ошибка и пропуск отнимают 3 секунды.",
  rulesBullets: [
    "Отвечает только тот, чей ход. Второй молчит!",
    "Чтобы пропустить картинку, скажи «skip» (или «გამოტოვება»).",
    "Если мы не расслышали, повтори — время не отнимается.",
    "Два ответа через «или» и отрицание («это не…») не засчитываются.",
  ],
  ready: "Мы готовы!",
  steps: ["Игроки", "Голос", "Категория", "Правила"],
  playersTitle: "Кто играет?",
  playersSub: "Два игрока на одном телефоне. Можно добавить ещё — до шести.",
  playerN: "Игрок {n}",
  you: "Ты",
  guest: "Гость",
  addPlayer: "Добавить игрока",
  removePlayer: "Убрать",
  namePh: "Имя",
  nameRequired: "У каждого игрока должно быть имя",
  namesUnique: "Имена должны различаться",
  next: "Дальше",
  back: "Назад",
  saveNote: "Твои матчи и статистика сохраняются в профиле. Результат гостя в твою статистику не входит.",
  loginNote: "Войди, чтобы сохранять историю матчей и голосовой профиль.",
  micTitle: "Микрофон",
  micWhy: "Игра принимает ответы голосом. Микрофон включён только во время игры.",
  micAllow: "Включить микрофон",
  micDenied: "Доступ к микрофону заблокирован. Разреши его в настройках браузера и попробуй снова.",
  micMissing: "Микрофон не найден.",
  micInsecure: "Микрофон работает только на защищённой (https) странице.",
  sttUnavailable: "В этом браузере распознавание речи не работает. Открой игру в Chrome или Edge.",
  privacyServer: "Голос отправляется только для распознавания ({provider}) и не хранится. Мы храним только текст — что услышала система.",
  privacyBrowser: "Распознавание делает браузер (в Chrome — сервис Google). Мы получаем только текст.",
  testTitle: "Проверка голоса",
  testSub: "{name}, скажи эти пять слов. Проверка пройдена, когда распознаны все пять.",
  testSay: "Скажи:",
  testHeard: "Услышали: {text}",
  testNothing: "Ничего не расслышали",
  testRetry: "Это слово ещё раз",
  testPassed: "Голос проверен ✓",
  testLang: "Язык проверки",
  testProfile: "Голосовой профиль подтверждён ({date})",
  testRetake: "Пройти заново",
  testUseProfile: "Продолжить с профилем",
  testKeep: "Хранить записи проверки {days} дней (зашифровано, только для меня)",
  testListening: "Слушаю…",
  testChecking: "Проверяю…",
  testLevel: "Уровень микрофона",
  testTooQuiet: "Тебя очень тихо слышно — говори ближе к телефону.",
  catTitle: "Выбери категорию",
  catCount: "{n} картинок",
  catLoadError: "Не удалось загрузить категории",
  countdownGo: "Поехали!",
  turnOf: "Ход: {name}",
  listening: "Слушаю",
  hearing: "Слышу…",
  checking: "Проверяю…",
  correct: "Верно!",
  wrong: "Неверно",
  skip: "Пропуск",
  minus3: "−3 секунды",
  itWas: "Это было: {answer}",
  unclear: "Не расслышали — повтори",
  ignored: "Не засчитано",
  negated: "Отрицание не засчитывается",
  multiple: "Назови один ответ",
  other: "Это что-то другое",
  heard: "Услышали: «{text}»",
  techPause: "Техническая пауза",
  techPauseText: "Сервис распознавания не ответил. Часы остановлены — никто не теряет время.",
  pausedTitle: "Пауза",
  pausedText: "Часы остановлены.",
  resume: "Продолжить",
  quit: "Закончить игру",
  quitConfirm: "Закончить сейчас? Этот матч не попадёт в историю.",
  out: "Время вышло!",
  lastSeconds: "Последние секунды!",
  bankEmpty: "Картинки закончились — побеждает тот, у кого больше времени.",
  loadingPictures: "Загружаем картинки…",
  winner: "Победил(а) {name}!",
  draw: "Ничья!",
  soloScore: "{n} верных ответов",
  statsCorrect: "Верно",
  statsWrong: "Ошибки",
  statsSkips: "Пропуски",
  statsTime: "Осталось",
  statsThink: "В среднем",
  rematch: "Реванш",
  changeCategory: "Другая категория",
  toHistory: "История",
  review: "Что услышала система",
  saved: "Матч сохранён",
  saveFailed: "Не удалось сохранить матч",
  unverified: "Не проверен",
  historyTitle: "История матчей",
  historyEmpty: "Матчей пока нет. Пора сыграть первый!",
  historyLogin: "Войди, чтобы увидеть историю.",
  won: "Победа",
  lost: "Поражение",
  drew: "Ничья",
  seconds: "{n} с",
  detailTitle: "Детали матча",
  notFound: "Матч не найден",
  verdicts: { correct: "Верно", wrong: "Ошибка", skip: "Пропуск", unclear: "Неясно", ignored: "Не засчитано", error: "Тех. ошибка" },
  accStats: "Статистика",
  accMatches: "Матчи",
  accWins: "Победы",
  accAccuracy: "Точность",
  accThink: "Ср. время ответа",
  accBest: "Лучшая категория",
  accVoice: "Голосовой профиль",
  accVoiceNone: "Голосового профиля пока нет. Он создаётся при первой игре.",
  accVoicePassed: "Подтверждён: {date} · язык: {lang}",
  accVoiceStored: "Что мы храним",
  accVoiceStoredList: ["Слова проверки и что услышала система", "Результат проверки и дату", "Уровни микрофона (фоновый шум и громкость голоса), чтобы лучше распознавать голос"],
  accVoiceNotStored: "Аудио матчей мы не храним. Записи проверки — только с твоего согласия, зашифрованно и {days} дней.",
  accSamples: "Сохранённые записи",
  accSamplesNone: "Записи не хранятся.",
  accKeepSamples: "Хранить записи проверки",
  accSamplesOff: "На этом сервере хранение записей отключено.",
  accRetake: "Пройти проверку заново",
  accDelete: "Удалить голосовой профиль",
  accDeleteConfirm: "Будут удалены профиль, проверки и все записи. Уверен?",
  accDeleted: "Голосовой профиль удалён",
  play: "Прослушать",
  delete: "Удалить",
  langs: { ka: "Грузинский", en: "Английский" },
  online: {
    start: "Онлайн-комната",
    badge: "онлайн",
    sub: "Каждый — со своего телефона. Один код, одна комната.",
    create: "Создать комнату",
    nameTitle: "Онлайн-комната",
    lobbyNote: "Каждый отвечает со своего телефона: сначала проверка голоса на 5 словах, потом — у каждого свои 60 секунд.",
    catLabel: "Категория",
    change: "Изменить",
    hostPicks: "Категорию выбирает ведущий",
    checkTitle: "Проверка голоса",
    checkSub: "Каждый проверяет голос на своём телефоне. Когда все будут готовы, игра начнётся сама.",
    checkReady: "Готово",
    checkPending: "Проверяет…",
    checkLeft: "Вышел из игры",
    waitingFor: "Ждём: {names}",
    youPassed: "Твой голос готов. Ждём остальных.",
    spectator: "Ты смотришь. Игроки отвечают со своих телефонов.",
    yourTurn: "Твой ход — говори!",
    quiet: "Сейчас отвечает {name}. Твой микрофон отдыхает.",
    micNote: "Микрофон слушает только в твой ход.",
    resumeHint: "Продолжить может ведущий или тот, чей сейчас ход.",
    waitHost: "Ведущий решает, что дальше.",
    toLobby: "Назад в комнату",
    callOff: "Прервать матч",
    callOffConfirm: "Матч остановится, результат не сохранится. Прервать?",
    calledOff: "Матч прерван",
    onlyServer: "Онлайн-комнаты работают только в полной версии",
    sendFailed: "Ответ не дошёл — скажи ещё раз",
  },
  errors: {
    no_content: "Эта категория ещё не готова",
    rate_limited: "Слишком много запросов — попробуй чуть позже",
    stt_unavailable: "Сервис распознавания речи недоступен",
    network: "Соединение прервалось",
    server: "Ошибка сервера — попробуй ещё раз",
  },
};

const DICTS: Record<Lang, GuessDict> = { ka, en, ru };

export function useGuessDict(): GuessDict {
  return useLocalDict(DICTS);
}

export function guessDict(lang: Lang): GuessDict {
  return DICTS[lang];
}
